import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateOpoContactFormValues } from '../types';
import { OpoMembershipRoleForm } from './OpoMembershipRoleForm';

type Props = {
  fields: Record<'id', string>[];
  isReadOnly?: boolean;
  isRequired?: boolean;
};

export const OpoMembershipList = memo(({ fields, isReadOnly = false, isRequired = false }: Props) => {
  const { control } = useFormContext<CreateOpoContactFormValues>();

  const memberships = useWatch({ control, name: 'memberships' });

  return (
    <>
      {fields.map((field, index) => {
        const membership = memberships?.[index];

        if (!membership) return null;

        return (
          <OpoMembershipRoleForm
            key={field.id}
            index={index}
            orgName={membership.opoOrganization?.name ?? ''}
            isReadOnly={isReadOnly}
            isRequired={isRequired}
          />
        );
      })}
    </>
  );
});

OpoMembershipList.displayName = 'OpoMembershipList';
